import { combineReducers } from '@reduxjs/toolkit';

import mosaferatiBimehNamehDetailSlice from '../../Detail/Actions/reducer';
import elhaghiyehHayeSaderehSlice from '../../ElhaghiyehHayeSadereh/Actions/reducer';
import mosaferatiEstelamSlice from '../../Estelam/Actions/reducer';

export const mosaferatiReducers = combineReducers({
  estelam: mosaferatiEstelamSlice,
  bimehNamehDetail: mosaferatiBimehNamehDetailSlice,
  elhaghiyehHayeSadereh: elhaghiyehHayeSaderehSlice,
} as any);
